import { render, staticRenderFns } from "./RelatedProfiles.vue?vue&type=template&id=fba0ffb8&scoped=true&"
import script from "./RelatedProfiles.vue?vue&type=script&lang=js&"
export * from "./RelatedProfiles.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProfiles.vue?vue&type=style&index=0&id=fba0ffb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba0ffb8",
  null
  
)

export default component.exports